<div
  [class.opacity-0]="this.selectedQuadrant() === SelectedQuadrant.Full"
  [class.opacity-1]="this.selectedQuadrant() !== SelectedQuadrant.Full"
  class="m-auto mt-4 flex h-6 items-center text-h1 font-semibold text-text-black transition-all"
>
  {{ this.selectedQuadrant() }}
</div>
<div class="sticky top-0 z-[100] flex min-h-16 items-center justify-center gap-2 pb-6">
  @if (perioExamOptions().length > 0) {
    <div class="flex items-center gap-2 rounded-3xl bg-text-white px-4 py-3 shadow-side-button">
      @if (!compareSelected()) {
        <lib-dropdown
          [disabled]="loading()"
          [value]="selectionDate()"
          [options]="perioExamOptions()"
          [prefixIcon]="perioExamDropdownPrefixIcon()"
          [prefixIconTooltip]="perioExamPrefixIconTooltip()"
          (valueChange)="onSelectionChange($any($event))"
        >
        </lib-dropdown>
        <button
          class="group btn-text flex flex-col"
          [libUiTooltip]="!editPerioExamFeatureEnabled() ? editUnavailableTooltip : undefined"
          [disabled]="
            perioExamOptions().length < 1 ||
            selectedPerioExam()?.provisionalStatus !== ProvisionalStatus.READY ||
            !editPerioExamFeatureEnabled()
          "
          (click)="onEditClick()"
        >
          <svg-icon
            class="text-primary-blue group-disabled:text-background-disabled"
            key="px-24-edit"
            width="24px"
            height="24px"
            size="md"
          ></svg-icon>
          <span class="text-h7 font-semibold text-primary-blue group-disabled:text-background-disabled">
            {{ 'perio_edit_label' | translate }}
          </span>
        </button>
        <button class="group btn-text flex flex-col" [disabled]="perioExamOptions().length < 2" (click)="onCompareClick()">
          <svg-icon
            class="text-primary-blue group-disabled:text-background-disabled"
            key="px-24-timeline"
            width="24px"
            height="24px"
            size="md"
          ></svg-icon>
          <span class="text-h7 font-semibold text-primary-blue group-disabled:text-background-disabled">
            {{ 'perio_compare_label_compare' | translate }}
          </span>
        </button>
      } @else {
        <div class="flex h-10 flex-col justify-center gap-y-1 overflow-hidden rounded-2xl bg-background-light-blue px-3" @growWidth>
          <h6 class="typo-h8-light truncate text-text-tertiary">{{ 'perio_compare_label_current_exam' | translate }}</h6>
          <h4 class="typo-h4-medium text-text-primary">
            {{ selectedPerioExam()?.date | date: 'MM/dd/yyyy' }}
          </h4>
        </div>

        <lib-dropdown
          class="overflow-hidden"
          [label]="'perio_compare_label_previous_exam' | translate"
          [withFloatingLabel]="true"
          [disabled]="loading()"
          [hasMinWidth]="false"
          [value]="previousSelectionDate()"
          [options]="previousPerioExamOptionsSignal()"
          (valueChange)="onPreviousSelectionChange($any($event))"
          @growWidth
        >
        </lib-dropdown>

        <lib-button-group>
          <button
            libButtonGroupElement
            [active]="compareSelected() === SelectedCompare.PocketDepth"
            class="btn-text truncate"
            [ngClass]="{ 'bg-primary-blue text-text-white': compareSelected() === SelectedCompare.PocketDepth }"
            (click)="onPocketDepthClick()"
          >
            {{ 'perio_compare_button_pocket_depth' | translate }}
          </button>
        </lib-button-group>

        <button
          class="inline-grid h-6 w-6 place-items-center rounded-full bg-background-light-blue p-1"
          type="button"
          (click)="onCloseCompareClick()"
        >
          <svg-icon class="text-primary-blue" key="px-16-x" size="sm"></svg-icon>
        </button>
      }
    </div>
  }
  <div class="absolute -z-10 flex w-full max-w-screen-lg items-center justify-end gap-6 px-20">
    <button [class]="hasExamDraft() && !perioSavingInProgress() ? 'btn-text' : 'btn-primary-big'" (click)="onNewExamClick()">
      {{ 'perio_new_exam_button' | translate }}
    </button>
    @if (hasExamDraft() && !perioSavingInProgress()) {
      <button class="btn-primary-big" (click)="onResumeExamClick()">{{ 'perio_resume_exam_button' | translate }}</button>
    }
  </div>
</div>
<lib-teeth
  #perioChart
  class="mx-auto mb-4 max-w-[1200px] flex-1 md:max-w-[1360px] lg:max-w-[1600px]"
  [ngClass]="{ 'pointer-events-none animate-pulse opacity-80 grayscale': loading() }"
  [currentTeeth]="selectedPerioExam()?.teeth ?? defaultTeeth()"
  [previousTeeth]="selectedPreviousPerioExam()?.teeth"
  [setCompareSelected]="compareSelected()"
  (clicked)="onToothSelected($event)"
></lib-teeth>

@if (!loading()) {
  <div
    class="absolute right-0 top-[220px] z-20 flex w-[72px] flex-col items-center justify-start gap-2 rounded-bl-3xl rounded-tl-3xl bg-text-white p-3 drop-shadow-lg"
  >
    <div class="text-h7 font-bold text-text-tertiary">{{ 'perio_view_button' | translate }}</div>
    <button
      [class.selected]="selectedQuadrant() === SelectedQuadrant.Full"
      type="button"
      class="flex h-[56px] w-[56px] flex-col items-center justify-center rounded-[18px] border-2 border-background-light-grey"
      (click)="selectQuadrant(SelectedQuadrant.Full)"
    >
      <svg-icon class="text-text-blue" key="px-24-fullmouth"></svg-icon>
      <span class="text-h7 font-semibold text-text-blue">{{ 'perio_full_button' | translate }}</span>
    </button>
    <button
      [class.selected]="selectedQuadrant() === SelectedQuadrant.UpperRight"
      type="button"
      class="flex h-[56px] w-[56px] flex-col items-center justify-center rounded-[18px] border-2 border-background-light-grey"
      (click)="selectQuadrant(SelectedQuadrant.UpperRight)"
    >
      <svg-icon class="text-text-blue" key="px-24-qur"></svg-icon>
      <span class="text-h7 font-semibold text-text-blue">{{ 'perio_ur_button' | translate }}</span>
    </button>
    <button
      [class.selected]="selectedQuadrant() === SelectedQuadrant.UpperLeft"
      type="button"
      class="flex h-[56px] w-[56px] flex-col items-center justify-center rounded-[18px] border-2 border-background-light-grey"
      (click)="selectQuadrant(SelectedQuadrant.UpperLeft)"
    >
      <svg-icon class="text-text-blue" key="px-24-qul"></svg-icon>
      <span class="text-h7 font-semibold text-text-blue">{{ 'perio_ul_button' | translate }}</span>
    </button>
    <button
      [class.selected]="selectedQuadrant() === SelectedQuadrant.LowerLeft"
      type="button"
      class="flex h-[56px] w-[56px] flex-col items-center justify-center rounded-[18px] border-2 border-background-light-grey"
      (click)="selectQuadrant(SelectedQuadrant.LowerLeft)"
    >
      <svg-icon class="text-text-blue" key="px-24-qll"></svg-icon>
      <span class="text-h7 font-semibold text-text-blue">{{ 'perio_ll_button' | translate }}</span>
    </button>
    <button
      [class.selected]="selectedQuadrant() === SelectedQuadrant.LowerRight"
      type="button"
      class="flex h-[56px] w-[56px] flex-col items-center justify-center rounded-[18px] border-2 border-background-light-grey"
      (click)="selectQuadrant(SelectedQuadrant.LowerRight)"
    >
      <svg-icon class="text-text-blue" key="px-24-qlr"></svg-icon>
      <span class="text-h7 font-semibold text-text-blue">{{ 'perio_lr_button' | translate }}</span>
    </button>
  </div>
}
<ng-template #editUnavailableTooltip
  ><span class="text-h7">{{ 'perio_edit_unavailable' | translate }}</span>
</ng-template>
<router-outlet></router-outlet>
